import React from "react";
import img1 from '../../assets/new images/career1.png';
import img2 from '../../assets/new images/career2.png';
import img3 from '../../assets/new images/career3.png';
import img4 from '../../assets/new images/career4.png';
const features = [
  {
    title: "Resume & Branding",
    desc: "Craft a standout resume and online presence that reflects your strengths and career goals",
    icon: img1,
  },
  {
    title: "Interview Skills ",
    desc: "Master communication, confidence, and interview techniques to leave a lasting impression",
    icon: img2,
  },
  {
    title: "Career Switch & Upskilling",
    desc: "Transition smoothly into new roles with tailored learning paths and skill upgrades",
    icon: img3,
  },
  {
    title: "Industry-Focused Paths",
    desc: "Identify the most in-demand skills in your field and align your growth for the future",
    icon: img4,
  },
];

const CareerGuide = () => (
  <section className="py-20 bg-gray-50 text-center">
    <h2 className="text-5xl font-bold text-gray-800 mb-8">Your Path to Career Growth</h2>
    <p className="max-w-2xl mx-auto text-center text-gray-600 mb-12">
    Discover step-by-step guides designed by mentors and AI experts. Learn practical strategies to<br />  build skills, switch careers, and achieve your goals with confidence
    </p>
    <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
      {features.map((f, i) => (
        <div key={i} className="bg-white flex flex-col gap-2 justify-center items-center p-10 shadow rounded-xl">
          <div className="bg-[#EE5F2B1A]/10 p-4 rounded-xl mb-4">
          <img src={f.icon} alt="" className="w-8 h-8"/>
          </div>
          <h3 className="font-semibold text-xl mb-2">{f.title}</h3>
          <p className="text-gray-600 ">{f.desc}</p>
        </div>
      ))}
    </div>
  </section>
);

export default CareerGuide;
